import { UserConstant } from '../constants';

const initialState = {};

export default (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case UserConstant.SET_USER:
      return { ...state, detail: payload };
    case UserConstant.SET_USERS:
      return { ...state, list: payload };
    default:
      return state;
  }
};
